// import React from "react"
import PropTypes from "prop-types"

const Sponsor = ({ sponsorLogo, height }) => {
    return null
}

Sponsor.propTypes = {
    sponsorLogo: PropTypes.string.isRequired,
    height: PropTypes.string.isRequired,
}

export default Sponsor
